var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0831 6.59999V10.8917C16.0831 13.4583 14.6165 14.5583 12.4165 14.5583H5.09147C4.71647 14.5583 4.35813 14.525 4.0248 14.45C3.81647 14.4167 3.61647 14.3584 3.43314 14.2917C2.18314 13.825 1.4248 12.7417 1.4248 10.8917V6.59999C1.4248 4.03332 2.89147 2.93335 5.09147 2.93335H12.4165C14.2831 2.93335 15.6248 3.72501 15.9831 5.53335C16.0415 5.86668 16.0831 6.20832 16.0831 6.59999Z",
    stroke: "#997950",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.5837 9.10009V13.3918C18.5837 15.9584 17.1171 17.0584 14.9171 17.0584H7.59206C6.97539 17.0584 6.41706 16.9751 5.93373 16.7918C4.94206 16.4251 4.26706 15.6668 4.02539 14.4501C4.35872 14.5251 4.71706 14.5584 5.09206 14.5584H12.4171C14.6171 14.5584 16.0837 13.4584 16.0837 10.8918V6.60009C16.0837 6.20842 16.0504 5.85845 15.9837 5.53345C17.5671 5.86678 18.5837 6.98342 18.5837 9.10009Z",
    stroke: "#997950",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74982 10.9501C9.96484 10.9501 10.9498 9.96509 10.9498 8.75006C10.9498 7.53503 9.96484 6.55005 8.74982 6.55005C7.53479 6.55005 6.5498 7.53503 6.5498 8.75006C6.5498 9.96509 7.53479 10.9501 8.74982 10.9501Z",
    stroke: "#997950",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.9834 6.91675V10.5834",
    stroke: "#997950",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5166 6.91675V10.5834",
    stroke: "#997950",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.38a2bce521b4232afad3a05618a881f4.svg";
export { ForwardRef as ReactComponent };